import { apiPost } from "../utils";
import { apiKey } from "../constants";

export function getBestInsuranceAPI (data){
   let newdata = JSON.stringify(data);
   return apiPost(`/api/bestinsurance?appKey=${apiKey}`, newdata);
}
